import { gql } from '@apollo/client'

export const FETCH_PATIENT = gql`
  query FetchPatient($patientId: UID!) {
    patient(id: $patientId) {
      id
      clientId
      businessId
      name
      photo
      photoThumbnail
      genderEntity {
        id
        name
        createdAt
        updatedAt
      }
      spayedNeuteredStatus
      spayedNeutered
      dateOfBirth
      acquiredDate
      approximateDateOfBirth
      microchipNumber
      externalId
      active
      displayId
    }
  }
`

export const FETCH_PATIENT_WITH_PMR_DATA = gql`
  query FetchPatientWithPmrData($patientId: UID!) {
    patient(id: $patientId) {
      id
      previousMedicalRecord {
        id
        priorVetCareStatus {
          id
          name
        }
        consentStatus {
          id
          name
        }
        internalNotes
        contacts {
          id
          businessId
          name
          typeId {
            id
            name
          }
          phone
          email
          website
          address
          suite
          city
          country
          state
          zip
          notes
          kyriosId
          clinicStatus
        }
        createdAt
        updatedAt
      }
    }
  }
`
